export enum UserRole {
    admin = 'admin',
    user = 'user',
}

export enum ParentRole {
    mother = 'mother',
    father = 'father',
    other = 'other',
}

export enum College {
    LMU = 'LMU',
    Lehigh = 'Lehigh',
}

export enum StudentGender {
    daughter = 'daughter',
    son = 'son',
    preferNotToAnswer = 'preferNotToAnswer',
}

export const StudentGenderToLabel: Record<StudentGender, string> = {
    [StudentGender.son]: 'Male',
    [StudentGender.daughter]: 'Female',
    [StudentGender.preferNotToAnswer]: 'Non-Binary',
};
